// extracted by mini-css-extract-plugin
export default {"badge":"FavoriteFlagButton_badge__16M3R","flagged":"FavoriteFlagButton_flagged__6Vp6w"};